<div class="container-fluid box-detail pd-0" [class]="{'mg-0': !showButton}">
  <mat-dialog-actions *ngIf="close">
    <button class="btn close" type="button" mat-dialog-close></button>
  </mat-dialog-actions>
  <div class="page-content pd-0">
    <div class="row box-info pd-top">
      <div class="col-md-5">
        <label class="required">{{'Name' | translate}}</label>
        <p class="fs-20"><b>{{detail?.name}}</b></p>
      </div>
      <div class="col-md-5">
        <label>id</label>
        <p class="fs-20"><b>{{detail?.identifier}}</b></p>
      </div>
      <div class="col-md-2">
        <button [routerLink]="['/admin/company/edit-info']" *ngIf="showButton"
          class="btn btn-primary">{{'Edit Information' | translate}}</button>
      </div>
    </div>
    <hr>
    <div class="row box-info mt-30 mb-10">
      <div class="col-md-3">
        <div class="com-info-img">
          <img [src]="detail?.logo" width="100%" onerror="this.src='/assets/images/common/small_logo.png'">
        </div>
      </div>
      <div class="col-md-9">
        <div class="row mg-0">
          <div class="col-md-12">
            <label class="required">{{'Address' | translate}}</label>
            <p class="fs-18">{{detail?.address}}</p>
          </div>
          <div class="col-md-6 mt-30">
            <label>{{'Phone' | translate}}</label>
            <div class="box-contact">
              <p class="fs-18" *ngFor="let number of detail?.contact_number">{{number}}</p>
            </div>
          </div>
          <div class="col-md-6 mt-30">
            <label>{{'Email' | translate}}</label>
            <div class="box-contact">
              <p class="fs-18" *ngFor="let email of detail?.contact_email"><a
                  [href]="'mailto:' + detail?.main_contact?.contact_email | safe">{{email}}</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row box-info pr-15">
      <div class="col-md-3 pt-10">
        <div class="com-info-img">
          <iframe frameborder="0" style="border:0" width="100%" height="100%"
            [src]="detail?.google_map_link + '&output=embed' | safe"></iframe>
        </div>
      </div>
      <div class="col-md-9 pt-10">
        <div class="border-top"></div>
        <div class="row mg-0">
          <div class="col-md-6 mt-15">
            <div class="form-group">
              <label class="required">{{'Request Credentials' | translate}}</label>
              <p class="fs-18">{{detail?.privacy_status_name}}</p>
            </div>
            <div class="form-group mt-30">
              <label>{{'Persona' | translate}}</label>
              <p class="fs-18">{{detail?.personas_joined}}</p>
            </div>
          </div>
          <div class="col-md-6 mt-15">
            <label>{{'Tags' | translate}}</label>
            <div>
              <span class="badge badge-pill badge-blue" *ngFor="let tag of detail?.tags">{{tag}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    @if(licenceDetail) {
      <hr>
    <div class="row box-info">
      <div class="col-md-10">
        <label>{{'Licence Information' | translate}}</label>
      </div>
      <div class="col-md-2">
        @if(showButton && !isReferredCompany) {
          <button [routerLink]="['/admin/company/edit-licence']"
          class="btn btn-primary">{{'Edit Licence' | translate}}</button>
        }
      </div>
      <div class="col-md-4">
        <label>{{'Licence' | translate}}</label>
        <p class="fs-18">{{isReferredCompany? 'Referred by ' + detail?.referring_company : licenceDetail?.licence_name}}</p>
      </div>
      <div class="col-md-4">
        <label for="">{{'Duration' | translate}}</label>
        <p class="fs-18">{{licenceDetail?.licence_rate_name}} ({{licenceDetail?.durationTime}})</p>
      </div>
      <div class="col-md-4">
        @if(!isReferredCompany) {
        <label for="">{{'Rate' | translate}}</label>
        <p class="fs-18">{{licenceDetail?.licencePrice}} USD / {{licenceDetail?.licence_rate_name}}</p>
        }
      </div>
      <div class="col-md-4"></div>
      <div class="col-md-4">
        <label for="">{{'White Collar Users' | translate}}</label>
        <div class="info-users">
          <p class="fs-18">{{detail?.users_summary?.white_actived}} / {{licenceDetail?.white_collar_users}} {{'users' | translate}}</p>
          <div class="slider">
            <mat-slider
              class="slider-user"
              [max]="100"
              [min]="0"
              [step]="0.1"
              [disabled]="true"
            >
              <input matSliderThumb [(ngModel)]="licenceDetail.whitePercent">
            </mat-slider>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <label for="">{{'Blue Collar Users' | translate}}</label>
        <div class="info-users">
          <p class="fs-18">{{detail?.users_summary?.blue_actived}} / {{licenceDetail?.blue_collar_users}} {{'users' | translate}}</p>
          <div class="slider">
            <mat-slider
            class="slider-user"
            [max]="100"
            [min]="0"
            [step]="0.1"
            [disabled]="true"
          >
            <input matSliderThumb [(ngModel)]="licenceDetail.bluePercent">
          </mat-slider>
          </div>
        </div>
      </div>
      @if (!isReferredCompany) {
        @for (item of licenceDetail?.referred_companies; track item) {
          <div class="col-md-4">
            <label for="">{{'Company Referred' | translate}}</label>
            <p class="fs-18">{{item.company_referred_name}}</p>
          </div>
          <div class="col-md-4">
            <label for="">{{'White Collar Users' | translate}}</label>
            <div class="info-users">
              <p class="fs-18">{{item.white_actived}} / {{item.allowed_white_collar_users}} {{'users' | translate}}</p>
              <div class="slider">
                <mat-slider
                  class="slider-user"
                  [max]="item.allowed_white_collar_users || 0"
                  [min]="0"
                  [step]="1"
                  [disabled]="true"
                >
                  <input matSliderThumb [(ngModel)]="item.white_actived">
                </mat-slider>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <label for="">{{'Blue Collar Users' | translate}}</label>
            <div class="info-users">
              <p class="fs-18">{{item.blue_actived}} / {{item.allowed_blue_collar_users}} {{'users' | translate}}</p>
              <div class="slider">
                <mat-slider
                  class="slider-user"
                  [max]="item.allowed_blue_collar_users || 0"
                  [min]="0"
                  [step]="1"
                  [disabled]="true"
                >
                  <input matSliderThumb [(ngModel)]="item.blue_actived">
                </mat-slider>
              </div>
            </div>
          </div>
        }
      }
    </div>
    }
    <hr>
    <div class="row box-info ">
      <div class="col-md-10 mt-15">
        <label>{{'Locations' | translate}}</label>
        <div class="box-address" *ngFor="let lo of detail?.locations">
          <p>{{lo.name}}</p>
          <p>{{lo.address}}</p>
          <p class="text-truncate"><a href="{{lo.google_map_link}}" target="_blank">{{lo.google_map_link}}</a></p>
        </div>
      </div>
      <div class="col-md-2 mt-15">
        <button [routerLink]="['/admin/company/edit-persona']" *ngIf="showButton"
          class="btn btn-primary">{{'Edit Persona' | translate}}</button>
      </div>
    </div>
    <hr *ngIf="detail?.regulatory?.is_allowed">
    <div *ngIf="detail?.regulatory?.is_allowed" class="box-info">
      <div class="row">
        <div class="col-md-12 mt-15">
          <label>{{'Regulatory filing' | translate}}</label>
          <small>&nbsp;{{'(Only available for Shipper persona in Singapore)' | translate}}</small>
          <mat-slide-toggle [checked]="detail?.regulatory?.regulatory_status" (toggleChange)="changeRegulatoryStatus()" style="float: right;"></mat-slide-toggle>
        </div>
      </div>
      <div *ngIf="detail?.regulatory?.regulatory_status" class="row">
        <div class="col-md-10">
          <div class="row">
            <div class="col-md-6">
              <label>{{'UEN' | translate}}</label>
              <div>
                <p class="fs-18">{{detail?.regulatory?.uen}}</p>
              </div>
            </div>
            <div class="col-md-6">
              <label>{{'TradeWeb ID' | translate}}</label>
              <div>
                <p class="fs-18">{{ detail?.regulatory?.tradeweb_id}}</p>
              </div>
            </div>
            <div class="col-md-6">
              <label>{{'Status' | translate}}</label>
              <div>
                <p class="fs-18">{{ detail?.regulatory?.status_name}}</p>
              </div>
            </div>
            <div class="col-md-6">
              <label>{{'Duration' | translate}}</label>
              <div *ngIf="detail?.regulatory?.start_date && detail?.regulatory?.end_date">
                <p class="fs-18">
                  {{ detail?.regulatory?.start_date | date: 'dd/MM/yy' }} to {{ detail?.regulatory?.end_date | date: 'dd/MM/yy' }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-2">
          <button (click)="openDetailRegulatory()" class="btn btn-primary">
            {{'Details' | translate}}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="!close" style="height: 24px; width: 100%;"></div>
